/**
 * Global Imports
*/

import React, { useState } from 'react';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';
import { Menu, MenuItem as BaseMenuItem } from '~/components/Widget';

/**
 * Local Imports
*/

import { GuestRouter } from '../../Routers/Guest';

/**
 * Locals
*/

/**
 * 
 */
function MenuItem(props) {
  /** Renderers **/

  /**
   * 
   */
  const render = ({ className, handleClick }) => {
    return (
      <div
        className={ CssClassName(className) }
        onClick={ !props.disabled ? handleClick : undefined }
      >
        { props.name }
      </div>
    );
  }

  /** Output **/

  return (
    <BaseMenuItem
      { ...props }
      className={
        CssClassName([
          'p-3 border-b-4',
          !props.active && 'cursor-pointer hover:text-indigo-800 hover:border-indigo-200',
           props.active && 'cursor-default text-indigo-800 border-indigo-400'
        ])
      }
    >
      { render }
    </BaseMenuItem>
  );
}

/**
 * Exports
*/

export const LayoutContext = React.createContext({
  isBusy: false
});

export function GuestLayout(props) {
  /** States **/
  
  const [ isBusy, setIsBusy ] = useState(false);
  const [ mode, setMode ] = useState('Login');

  /** Renderers **/

  /**
   * 
   */
  const renderMenu = () => (
    <Menu
      default='Login'
      className='flex justify-center mb-4'
      disabled={ isBusy }
      onChange={ name => setMode(name.replace(' ', '')) }
    >
      <MenuItem name='Login' />
      <MenuItem name='Register' />
      <MenuItem name='Forgot Password' />
    </Menu>
  );
  
  /** Output **/
  
  return (
    <LayoutContext.Provider value={{ isBusy, setIsBusy }}>
      <div className='flex justify-center h-full guest'>
        <div className='flex flex-col w-full md:w-1/3 xl:w-1/4 mt-16'>
          <div className='p-4 rounded-md bg-white shadow'>
            <h1 className='mb-4 text-3xl text-center text-gray-500 font-bold'>
              { process.env.MIX_APP_NAME }
            </h1>
            { renderMenu() }
            <GuestRouter />
          </div>
        </div>
      </div>
    </LayoutContext.Provider>
  );
}